import { Outlet } from 'react-router-dom'

import { useState } from 'react'

import { ItemPromptDialog } from '@/components/pos/checkout/ItemPromptDialog'
import { CompanionWatch } from '@/components/pos/companion/CompanionControl'
import { CustomerDisplayFeed } from '@/components/pos/display/CustomerDisplayFeed'
import { ShortcutsDialog } from '@/components/pos/orders/ShortcutsDialog'
import { DevicesDialog } from '@/components/pos/settings/DevicesDialog'
import { LabelsDialog } from '@/components/pos/settings/LabelsDialog'
import { useHotkeys } from '@/hooks/ui/useHotkeys'

import { PosRail } from './PosRail'
import { RenewalAlertBar } from './RenewalAlertBar'

/**
 * The admin's frame, tightened for a till: black frame, a fixed icon rail instead of the full sidebar (the cashier
 * lives on one screen), and the white rounded panel inset 4px. Below `md` the rail moves to a bottom bar.
 */
export const PosLayout = () => {
  const [helpOpen, setHelpOpen] = useState(false)
  const [printerOpen, setPrinterOpen] = useState(false)
  const [labelsOpen, setLabelsOpen] = useState(false)
  useHotkeys({ help: () => setHelpOpen(true) })

  return (
    <div className="flex h-dvh flex-col bg-frame md:flex-row">
      <PosRail onShowShortcuts={() => setHelpOpen(true)} onShowPrinter={() => setPrinterOpen(true)} onShowLabels={() => setLabelsOpen(true)} />
      <main className="order-first m-1 mb-0 flex min-h-0 flex-1 flex-col overflow-hidden rounded-xl bg-page md:order-none md:mb-1 md:ml-0">
        <RenewalAlertBar />
        <div className="min-h-0 flex-1">
          <Outlet />
        </div>
      </main>
      <ShortcutsDialog open={helpOpen} onOpenChange={setHelpOpen} />
      <DevicesDialog open={printerOpen} onOpenChange={setPrinterOpen} />
      <LabelsDialog open={labelsOpen} onOpenChange={setLabelsOpen} />
      <CustomerDisplayFeed />
      <CompanionWatch />
      <ItemPromptDialog />
    </div>
  )
}
